import axios from "axios";
import BlumarConfig from '../blumar-config';

export default class ChatService {
	constructor() {
		this.url = new URL('/chat-api', BlumarConfig.webserviceUrl).href;
	}

	getWebSocketUrl() {
		return `${this.url}/websocket`;
	}

	findMessagesByGroupId(groupId) {
		return axios.get(`${this.url}/groups/${groupId}/messages`);
	}

	readUnseenMessages(groupId) {
		return axios.put(`${this.url}/groups/${groupId}/read-unseen-messages`);
	}

	sendMessage(groupId, message) {
		return axios.post(`${this.url}/groups/${groupId}/send-message`, message);
	}
}



// WEBPACK FOOTER //
// ./src/service/ChatService.js